/** 「はい／いいえ」の確認（同意モーダルと同じ見た目）。はいで true。note はメッセージの下に小さく出す補足 */
export function confirmDialog(message: string, opts: { yes?: string; no?: string; note?: string } = {}): Promise<boolean> {
  const { yes = 'はい', no = 'いいえ', note = '' } = opts;
  return new Promise((resolve) => {
    const el = document.createElement('div');
    el.className = 'modal-backdrop';
    el.innerHTML = `
      <div class="modal" role="alertdialog" aria-modal="true">
        <p class="modal-message"></p>
        <p class="modal-note"></p>
        <div class="modal-actions">
          <button class="btn" type="button" data-no></button>
          <button class="btn primary" type="button" data-yes></button>
        </div>
      </div>`;
    el.querySelector('.modal-message')!.textContent = message;
    el.querySelector('.modal-note')!.textContent = note;
    el.querySelector('[data-no]')!.textContent = no;
    el.querySelector('[data-yes]')!.textContent = yes;
    const done = (v: boolean) => {
      el.remove();
      resolve(v);
    };
    el.querySelector('[data-no]')!.addEventListener('click', () => done(false));
    el.querySelector('[data-yes]')!.addEventListener('click', () => done(true));
    document.body.append(el);
  });
}
